<template>
  <section class="section player-info">
    <div class="profile-container">
      <div class="user-info-nickname-results">
        <div class="avatar-container">
          <img
            :src="
              player.profile_info.avatar
                ? player.profile_info.avatar
                : require(`../assets/img/defaultAvatar.jpg`)
            "
            alt="avatar"
            class="avatar"
          />
        </div>
        <div class="user-info">
          <p class="user-info__nickname">{{ player.profile_info.nickname }}</p>
          <div class="user-info-container">
            <p class="user-info__latest-results-label">Ostatnie wyniki</p>
            <p class="user-info__latest_results">
              <template
                v-for="(result, index) in player.player_stats['Recent Results']"
              >
                <span
                  :key="index"
                  :class="{
                    'text-green': result == 1,
                    'text-red': result == 0
                  }"
                >
                  {{ result == 1 ? "W" : "L" }}
                </span>
              </template>
            </p>
          </div>
        </div>
      </div>
      <div class="lvl-icon">
        <img
          :src="getImgUrl(player.player_info.games.csgo.skill_level_label)"
          alt="lvl"
        />
      </div>
    </div>
    <div class="profile-stats-container">
      <ul class="profile-stats-list">
        <li class="profile-stats-item">
          <h3 class="profile-stats-item-heading">K/D Ratio</h3>
          <p class="profile-stats-item-value">
            {{ player.player_stats["Average K/D Ratio"] }}
          </p>
        </li>
        <div class="separator"></div>
        <li class="profile-stats-item">
          <h3 class="profile-stats-item-heading">Rozegrane mecze</h3>
          <p class="profile-stats-item-value">
            {{ player.player_stats["Matches"] }}
          </p>
        </li>
        <div class="separator"></div>
        <li class="profile-stats-item">
          <h3 class="profile-stats-item-heading">% Wygranych</h3>
          <p class="profile-stats-item-value">
            {{ player.player_stats["Win Rate %"] }}
          </p>
        </li>
        <div class="separator"></div>
        <li class="profile-stats-item">
          <h3 class="profile-stats-item-heading">ELO</h3>
          <p class="profile-stats-item-value">
            {{ player.player_info.games.csgo.faceit_elo }}
          </p>
        </li>
        <div class="separator"></div>
        <li class="profile-stats-item">
          <h3 class="profile-stats-item-heading">Headshot %</h3>
          <p class="profile-stats-item-value">
            {{ player.player_stats["Average Headshots %"] }}
          </p>
        </li>
      </ul>
    </div>
    <div class="profile-links-container">
      <a
        target="_blank"
        :href="
          `https://www.faceit.com/pl/players/${player.player_info.nickname}`
        "
        rel="nofollow"
        class="btn faceit-btn"
        ><img
          src="../assets/img/icons/Black_Pheasant.svg"
          alt="faceit-logo"
        />Profil Faceit</a
      >
      <a
        target="_blank"
        rel="nofollow"
        :href="
          `https://steamcommunity.com/profiles/${player.player_info.steam_id_64}/`
        "
        class="btn steam-btn"
        ><img
          src="../assets/img/icons/steam-symbol.png"
          alt="steam-logo"
        />Profil Steam</a
      >
    </div>
  </section>
</template>

<script>
export default {
  name: "PlayerInfo",
  props: ["player"],
  methods: {
    getImgUrl(lvl) {
      return require(`../assets/img/lvls/skill_level_${lvl}_svg.svg`);
    }
  }
};
</script>
